// extracted by mini-css-extract-plugin
export default {"h1":"H1title_h1__Wepyz","white":"H1title_white__2+d1m","center":"H1title_center__kEkln"};